const localStore = {
    setItem(name: string, data: string) {
        localStorage.setItem(name, data);
    },
    getItem(name: string) {
        return localStorage.getItem(name);
    },
    removeItem(name: string) {
        localStorage.removeItem(name);
    },
    getObjItem(key: string) {
        const data = localStorage.getItem(key);
        if (!data) return null;
        return JSON.parse(data);
    },
    getList(keys: string[]) {
        if (!keys) return [];
        return keys.map((key) => localStorage.getItem(key));
    }
};

export default localStore;

export function updateLocalStorage<T = any>(key: string | number, data: T) {
    try {
        const value = JSON.stringify(data);
        localStorage.setItem(String(key), value);
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}
